import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useToggle as $7KNc0$useToggle } from "@react-aria/toggle";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $b418ec0c85c52f27$exports = {};
$parcel$export($b418ec0c85c52f27$exports, "useSwitch", function () {
  return $b418ec0c85c52f27$export$d853f7095ae95f88;
});

function $b418ec0c85c52f27$export$d853f7095ae95f88(props, state, ref) {
  var _$7KNc0$useToggle = $7KNc0$useToggle(props, state, ref),
      inputProps = _$7KNc0$useToggle.inputProps;

  var isSelected = state.isSelected;
  return {
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      role: 'switch',
      checked: isSelected,
      'aria-checked': isSelected
    })
  };
}

export { $b418ec0c85c52f27$export$d853f7095ae95f88 as useSwitch };